<template>
    <form v-if="!isResetPasswordValid" class="register-form width-100prc" @submit.prevent="processPasswordChange" method="post">
        <div id="div-padlock" class="img-container">
            <img src="img/padlock.png"/> 
        </div>

        <h2 class="register-form__title text-center" id="form-entry">{{ TEXTS.render(`RESET_PASSWORD_FORM_HEADER`) }}</h2>
        <p class="text-danger font-sm mt-1 text-danger font-weight-bold" role="alert">{{error}}</p>

        <div class="row">
            <div class="col-md-12">
                <div class="form-group mb-4">
                    <label class="font-weight-bold mb-1 required" for="details-password">{{ TEXTS.render(`RESET_PASSWORD_FORM_PASSWORD_HEADER`) }}</label>
                    <input id="details-password" type="password" class="form-control" v-model="details.password" @keyup="validate" @paste="validate" :placeholder="TEXTS.render(`RESET_PASSWORD_FORM_PASSWORD_PLACEHOLDER`)">
                    <div class="register-form__validation mt-1 text-danger font-weight-bold" style="white-space: pre-wrap;" role="alert">{{validations.password}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <ColoredButton :disabled="isRequesting" :loadingState="isRequesting" class="skiptranslate">{{ TEXTS.render(`RESET_PASSWORD_FORM_BTN_RESET_PASSWORD`) }}</ColoredButton>
            </div>
        </div>
    </form>
    <form v-else class="register-form width-100prc center">
    
        <div id="div-padlock"  class="img-container">
            <img src="img/padlock.png"/> 
        </div>

        <h2 class="register-form__title text-center" role="status">{{ TEXTS.render(`RESET_PASSWORD_SUCCESS_HEADER`) }}</h2>
        <p class="text-danger font-sm font-weight-bold text-center">
            <a href="#/login" class="text-center">{{ TEXTS.render(`RESET_PASSWORD_LOGIN`) }}</a>
        </p>
    </form>
</template>

<script>
    import helper from '../../../../helper';
    import LoaderCircle from '../../../../common/components/LoaderCircle';
    import ColoredButton from '../../../../common/components/ColoredButton';
    import Texts from '../../../../common/utils/Texts'
    import RegistrationForm from '../../../../common/mixins/RegistrationForm'
    export default {
        mixins: [RegistrationForm],
        components: {
            LoaderCircle,
            ColoredButton
        },
        data() {
            return {
                details: {
                    password: '',
                    retypePassword: '',
                    email : this.$route.query.email,
                    resetToken : this.$route.query['reset_token']
                },
                validations: {
                    password: '',
                    retypePassword: '',
                    valid: true
                },
                
                isRequesting : false,
            }
        },
        methods: {
            processPasswordChange(event) {
                this.validate();
                this.resetResetPasswordRequest();
                if (this.validations.valid) {
                    this.$store.dispatch('validatePasswordResetAttempt', this.details);
                    var self = this;
                    setTimeout(() => {
                        self.isRequesting = true
                    }, 100);
                }
            },
            resetResetPasswordRequest(){
                this.$store.dispatch('clearResetPasswordError');
                this.$store.dispatch('clearResetPasswordResult');
            },
            resetValidation() {
                for (const key in this.validations) {
                    if (this.validations.hasOwnProperty(key)) {
                        if (typeof key === 'string') {
                            this.validations[key] = '';
                            continue;
                        }
                    }
                }
                this.validations.valid = true;
            },
            validate(event) {
                this.resetValidation();
                if (!(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,60}$/.test(this.details.password))) {
                    this.validations.valid = false;
                    this.validations.password = 'Password must include at least \n • One lower case letter \n • One upper case letter \n • One number \n • 8 characters';
                }
                if (this.details.password && this.details.retypePassword != '' && this.details.password !== this.details.retypePassword) {
                    this.validations.valid = false;
                    this.validations.retypePassword = 'Re-type Password is not equal to Password';
                }
            },
        },
        mounted() {
            this.resetResetPasswordRequest();
            localStorage.csoEnabled = this.$route.query && this.$route.query.cso === 'true' ? 'true' : 'false';
            this.csoEnabled = localStorage.csoEnabled;
        },
        computed: {
            TEXTS: ()=> Texts,
            loading() {
                return this.$store.getters['GET_PAGE_LOADING'];
            },
            resetPasswordResult() {
                return this.$store.getters.GET_RESET_PASSWORD_RESULT;
            },
            error() {
                var error = this.$store.getters.GET_RESET_PASSWORD_ERROR;
                this.isRequesting = false;
                helper.scrollToTop('form-entry');
                return error;
            },
            isResetPasswordValid(){ 
                var result = this.$store.getters.GET_RESET_PASSWORD_RESULT;
                this.isRequesting = false;
                var success = this.resetPasswordResult && this.resetPasswordResult.message == "Success" && !this.error;
                if(success){
                    this.$store.dispatch('resetNewPassword', {
                        email : this.details.email,
                        newpassword : this.details.password
                    });
                }
                return success;
            }
        },
    }

</script>

<style scoped>
#div-padlock{
    text-align: center;
    padding : 15px;
    padding-bottom: 90px;
}
.width-100prc{
    width: 100%;
}
</style>
